module.exports = __webpack_public_path__ + "static/media/full-mirchi.fab179d5.svg";